import { render } from "./RoomAvailability.vue?vue&type=template&id=fbbd3120"
import script from "./RoomAvailability.vue?vue&type=script&lang=js"
export * from "./RoomAvailability.vue?vue&type=script&lang=js"

import "@/modules/stay/css/room-availability.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__